<template>
	<v-menu offset-y>
		<template #activator="{ on }">
			<v-btn icon v-on="on" v-if="(deveExibirBotaoEstornar || deveExibirBotaoExcluir) && !isAtaCancelada">
				<v-icon class="font-size-grande material-icons">mdi-dots-vertical</v-icon>
			</v-btn>
		</template>
		<v-list class="pa-1">
			<v-list-item
				class="list-item-height"
				data-testid="action-estornar"
				@click="$emit('estornar')"
				v-if="deveExibirBotaoEstornar"
				v-az-auth="permissoes.pedidoUtilizacaoItemEstornar"
			>
				<v-icon :size="tamanhoIconeMenu" class="material-icons mr-2">mdi-clipboard-arrow-left</v-icon>
				<v-list-item-title class="texto-menu-interno">Estornar</v-list-item-title>
			</v-list-item>
			<v-list-item
				v-if="deveExibirBotaoExcluir"
				v-az-auth="permissoes.pedidoUtilizacaoItemExcluir"
				class="list-item-height"
				data-testid="action-estornar"
				@click="$emit('excluir')"
			>
				<v-icon :size="tamanhoIconeMenu" class="material-icons mr-2">mdi-delete</v-icon>
				<v-list-item-title class="texto-menu-interno">Excluir</v-list-item-title>
			</v-list-item>
		</v-list>
	</v-menu>
</template>
<script>
import arpBpmMixin from '@/views/mixins/bpm/arp-bpm-mixin'
import validacaoPedido from '@/views/mixins/validacaoPedido'
import fluxoPedido from '@/views/mixins/bpm/fluxoPedido'
import { mapGetters, mapState } from 'vuex'
import { getterTypes, situacoes } from '@/core/constants'
import tipos from '@/core/constants/tipos'

export default {
	name: 'acessar-pedido-itens-btn-acoes',
	mixins: [arpBpmMixin, validacaoPedido, fluxoPedido],
	inject: ['idPedido'],
	props: {
		item: {
			type: Object,
			required: true,
		},
		situacao: {
			type: String,
			required: true,
		},
	},
	data() {
		return {
			tamanhoIconeMenu: '18px',
		}
	},
	computed: {
		...mapGetters({
			isPedidoRascunho: getterTypes.PEDIDO.IS_PEDIDO_RASCUNHO,
		}),
		...mapState({
			infoPedido: (state) => state.pedido.informacoesPedido,
		}),
		deveExibirBotaoEstornar() {
			return (
				this.itemEstaEfetivado(this.item) &&
				this.hasAuthority &&
				this.isPermissaoAutorizada(this.permissoes.pedidoUtilizacaoItemEstornar) &&
				this.item.tipoEstorno !== tipos.TIPO_ESTORNO_ITEM_PEDIDO.ESTORNO_COMPLETO.value
			)
		},
		deveExibirBotaoExcluir() {
			return (
				(this.hasAuthority && !this.estaEmSituacaoOndeItemNaoPodeSerAlterado(this.situacao)) ||
				this.isPedidoRascunho
			)
		},
		isAtaCancelada() {
			return this.infoPedido.ataRegistroPreco?.situacao === situacoes.ATA.CANCELADO.value
		},
	},
	async mounted() {
		await this.carregarInstancia(this.idPedido)
	},
}
</script>
<style scoped lang="stylus">
.font-size-grande
	font-size 28px !important

.texto-menu-interno
	font-size 0.8em

.list-item-height
	min-height 0 !important

.v-list-item--disabled
	cursor not-allowed !important
</style>
